import React, { useState, useEffect, useCallback, useMemo } from 'react';
import '../Css/OrderExcel.css';
import '../Css/OrdersReport.css';
import { Link } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import Navbar from './Navbar';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { Typography, CircularProgress } from '@mui/material';
import { MdDownloadForOffline } from "react-icons/md";
import Logger from './Logger';
import { FaListUl } from "react-icons/fa";
import { getLoggerBaseURL } from '../utils/getLoggerBaseURL';

const OrderExcel = () => {
  const userEmail = sessionStorage.getItem("userEmail");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date());

  // Initialize Logger
  const logger = useMemo(() => new Logger(getLoggerBaseURL()), []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`/api/driver/excel/${selectedDate.toISOString()}/${userEmail}`);
      if (response.ok) {
        const responseData = await response.json();
        if (!responseData || responseData.length === 0) {
          logger.log('No data available for the selected date', 'INFO');
          setData([]);
          setLoading(false);
          return;
        }
        setData(responseData);
        setLoading(false);
      } else {
        logger.log('Failed to fetch data for Order Excel file', 'ERROR');
        setLoading(false);
      }
    } catch (error) {
      logger.log(`Error fetching data: ${error.message}`, 'ERROR');
      setLoading(false);
    }
  }, [selectedDate, userEmail, logger]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDownloadExcel = async () => {
    try {
      const response = await fetch(`/api/ordera/getExcel/${selectedDate.toISOString()}/${userEmail}`);
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'order.xlsx';
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        logger.log('Failed to download Excel report', 'ERROR');
      }
    } catch (error) {
      logger.log(`Failed ${error.message}`, 'ERROR');
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const filteredData = data.filter(item =>
    item.Rec_Name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className='New orders-report-page'>
      <Navbar />
      <div className="ordersReportToolbar">
        <h2 className="headS">
          <Link to="/Reports" className="reports">Reports</Link>
          <span className="crumbSep">{'>'}</span>
          <span className="reporter">Orders</span>
        </h2>
        <div className="ordersReportFilters">
          <input type="text" className="searchbarrs" placeholder="Search..." value={searchTerm} onChange={handleSearchChange} autoComplete="off" />
          <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="yyyy-MM-dd" className="dropdownO" />
          <div className='uploadSS'>
            <button className='choose-file-buttonn' onClick={handleDownloadExcel} style={{ background: 'rgb(121, 198, 233)', border: 'none', cursor: 'pointer', padding: '6px' }} data-tooltip-id="download-tooltip">
              <MdDownloadForOffline size={30} />
              <Tooltip id="download-tooltip" place="bottom" content="Get Excel Report" />
            </button>
          </div>
        </div>
      </div>
      {loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh' }}>
          <CircularProgress />
          <Typography variant="h6" style={{ marginTop: '20px' }}>Fetching Data...</Typography>
        </div>
      ) : (
        <table className='orderTT'>
          <thead>
            <tr>
              <th className='Oth'>Order No.</th>
              <th className='Oth'>Party Name</th>
              <th className='Oth'>Delivery Date</th>
              <th className='Oth'>Delivery Time</th>
              <th className='Oth'>Driver Email</th>
              <th className='Oth'>Invoice No.</th>
              <th className='Oth'>Invoice Amount</th>
              <th className='Oth'>Status</th>
              <th className='Oth'>Invoice Date</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td className="noOrders" colSpan="9">
                  <div className="center-content">
                    <div className="icon-wrapper">
                      <FaListUl className="icon" />
                    </div>
                    <span className="noOrdersMsg">No data available</span>
                  </div>
                </td>
              </tr>
            ) : (
              filteredData.map((item, index) => (
                <tr key={item._id}>
                  <td className='Otd'>{item.Order_No}</td>
                  <td className='Otd'>{item.Rec_Name}</td>
                  <td className='Otd'>{item.Del_Date_Actual ? item.Del_Date_Actual : 'N/A'}</td>
                  <td className='Otd'>{item.Del_Time_Actual ? item.Del_Time_Actual : 'N/A'}</td>
                  <td className='Otd'>{item.Driv_Email}</td>
                  <td className='Otd'>{item.INumber || "Not entered"}</td>
                  <td className='Otd'>₹ {item.amount}</td>
                  <td className='Otd'>
                    {item.Status === 4 || item.Status === 6 ? (
                      <span className="Success">Success</span>
                    ) : item.Status === 5 ? (
                      <span className="Fail">Fail</span>) : null}</td>
                  <td className='Otd'>
                    {item.IDate
                      ? new Date(item.IDate).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
                      : "Not entered"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default OrderExcel;